<template>
  <div v-if="booking.status.status === 'SCHEDULING'">
    <v-row :style="$vuetify.breakpoint.smAndDown ? 'display: block' : '' " class="main--text">
      <v-col>
        <h3>Service type</h3>
        {{ booking.vehicle.name }}
      </v-col>
      <v-col>
        <h3>Waste type</h3>
        {{ booking.waste.name }}
      </v-col>
      <v-col>
        <h3>Instruction</h3>
        {{ booking.instructions }}
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'SchedulingBooking',
  props: {
    booking: Object
  }
}
</script>

<style scoped>

</style>